/* eslint id-length: "off" */
import PropTypes from "prop-types";
import MDMusicArtwork from "@/components/music/md-player/MDMusicArtwork";
import MDMusicControls from "@/components/music/md-player/MDMusicControls";
import MDMusicPlaylist from "@/components/music/md-player/MDMusicPlaylist";
import MDMusicTrackInfo from "@/components/music/md-player/MDMusicTrackInfo";

const MDMusicMulti = ({
  activeIndex,
  controlProps,
  transportProps,
  onSelect,
  track,
  tracks,
}) => (
  <div className="mdmusic mdmusic-multi">
    <div className="mdmusic-multi-playlist">
      <MDMusicPlaylist activeIndex={activeIndex}
                       tracks={tracks}
                       onSelect={onSelect}
      />
    </div>
    <div className="mdmusic-multi-detail">
      <div className="mdmusic-multi-detail-head">
        <div className="mdmusic-multi-detail-art">
          <MDMusicArtwork size="large" track={track}/>
        </div>
        <div className="mdmusic-multi-detail-info">
          <MDMusicTrackInfo size="normal" track={track}/>
        </div>
      </div>
      <div className="mdmusic-multi-detail-controls">
        <MDMusicControls {...controlProps} {...transportProps}/>
      </div>
    </div>
  </div>
);

MDMusicMulti.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  controlProps: PropTypes.object.isRequired,
  transportProps: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  track: PropTypes.object.isRequired,
  tracks: PropTypes.array.isRequired,
};

export default MDMusicMulti;
